import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { useId } from '../../../internal/hooks';
import { useDeviceType } from '../../../responsive';
import { generateDataTestId } from '../../../internal/utils';
import { Radio } from '../Radio';
import { getStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
function RadioGroupComponent(props) {
  var options = props.options,
    value = props.value,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    invalid = props.invalid,
    onChange = props.onChange,
    horizontal = props.horizontal,
    role = props.role,
    dataTestId = props.dataTestId;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  var isControlled = React.useRef(props.hasOwnProperty('value'));
  var preparedOptions = React.useMemo(function () {
    return options.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        onChange: onChange && function (e) {
          return onChange(e, option.value);
        }
      });
    });
  }, [options, onChange]);
  var name = useId(props.name);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['radio-group'], horizontal ? styles['horizontal-group'] : styles['vertical-group']),
    role: role,
    children: preparedOptions.map(function (option) {
      var key = String(option.value);
      return /*#__PURE__*/_jsx(Radio, {
        // Приводится к строке, чтобы не ослаблять типы
        name: name,
        value: key,
        checked: isControlled.current ? value === option.value : undefined,
        defaultChecked: defaultValue !== undefined ? defaultValue === option.value : undefined,
        disabled: disabled,
        invalid: invalid,
        label: option.label,
        onChange: option.onChange,
        role: role === 'listbox' ? 'option' : undefined,
        dataTestId: generateDataTestId(dataTestId, [key])
      }, key);
    })
  });
}

/**
 * Компонент для работы с Radio как с группой
 *
 * @export
 * @param {IRadioGroupProps} props
 * @returns
 */
export var RadioGroup = /*#__PURE__*/React.memo(RadioGroupComponent);